import { render, staticRenderFns } from "./login.vue?vue&type=template&id=12253266"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"
import style0 from "./login.vue?vue&type=style&index=0&id=12253266&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports